/**
 * Copyright (c) Streamlit Inc. (2018-2022) Snowflake Inc. (2022-2024)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const STREAMLIT_HOME_URL = "https://streamlit.io"
export const DEPLOY_URL = "https://share.streamlit.io/deploy"
export const STREAMLIT_CLOUD_URL = "https://streamlit.io/cloud"
export const ONLINE_DOCS_URL = "https://docs.streamlit.io"
export const COMMUNITY_URL = "https://discuss.streamlit.io"

/** The URL customers are directed to for troubleshooting components. */
export const COMPONENT_DEVELOPER_URL =
  "https://docs.streamlit.io/develop/concepts/custom-components"

/** The URL customers are directed to for troubleshooting camera permissions. */
export const CAMERA_PERMISSION_URL =
  "https://docs.streamlit.io/knowledge-base/using-streamlit/enable-camera"

export const STREAMLIT_COMMUNITY_CLOUD_DOCS_URL =
  "https://docs.streamlit.io/deploy/streamlit-community-cloud/get-started"
export const STREAMLIT_DEPLOY_TUTORIAL_URL =
  "https://docs.streamlit.io/deploy/tutorials"
